<ap-modal #baseModalLargest
          [appModalId]="detailDiagModalId"
          [ariaLabel]="'Diagnostic detail view'"
          [closable]="true"
          [style]="{'width': '95vw', 'height': '85vh', 'max-height': '85vh'}"
          [contentStyle]="{'overflow': 'hidden', 'max-height': 'calc(85vh - 64px)', 'min-height': '420px', 'padding': '8px 16px 12px', 'display': 'flex', 'flex-direction': 'column', 'box-sizing': 'border-box'}"
          (onClose)="handleModalClosed()">
  <ng-template ngTemplate="header">
    @if (tableRowData != undefined) {
<div class="flex-fill d-flex align-items-center">
      <div style="display:flex">
        <h4 style="padding-top:5px">{{tableRowData.DIAG_DESC}}</h4>
        <span style="padding:12px 10px 3px 10px;font-size:17px"> - Criticality: @if ((tableRowData.DIAG_MSG === 'Critical') ||
                (tableRowData.DIAG_MSG  === 'Informational')) {
<span class="Appkit4-icon"
                    [ngClass]="{'icon-alert-fill': tableRowData.DIAG_MSG === 'Critical',
                                'icon-information-fill': tableRowData.DIAG_MSG === 'Informational'}"
                    [ngStyle]="{'color': tableRowData.DIAG_MSG === 'Critical' ? '#D04A02' : '#212121'}">
        </span>
}
        <span  [ngStyle]="{'color': tableRowData.DIAG_MSG === 'Critical' ? '#D04A02' : '#212121'}">
           {{ tableRowData.DIAG_MSG}}
        </span>

        </span>
        <span style="padding: 12px 7px 7px 0px;font-size: 17px;"> - Tax Year: {{tableRowData.TAX_YEAR}} </span>
      </div>
    </div>
}
  </ng-template>
  <div class="detail-diag-view-modal-body">
  @if (tableRowData != undefined) {
<div #viewHeight class="deatil-view-dialog pt-0" (click)="onModalClick()">
    <div class="diagnostic-section">
        <div class="section-label desc">
             Diagnostic Description
        </div>
        <p class="detail-text detail-desc" [class.show]="show">
            {{tableRowData.DIAG_DESCRIPTION != null ? tableRowData.DIAG_DESCRIPTION : 'Not Found'}}
            @if (tableRowData.DIAG_DESCRIPTION != null) {
<a class="read-more-link"
                   
                    (click)="show = !show">{{ show ? 'Read less': 'Read More' }}</a>
}
        </p>
    </div>
    <div class="diagnostic-section">
        <div class="section-label resolution" >
             Diagnostic Resolution
        </div>
        <p class="detail-text detail-resolution" [class.show_resolution]="show_resolution">
            {{tableRowData.DIAG_RESOLUTION != null ? tableRowData.DIAG_RESOLUTION : 'Not Found'}}
            @if (tableRowData.DIAG_RESOLUTION != null) {
<a class="read-more-link"
               
                (click)="show_resolution = !show_resolution">{{ show_resolution ? 'Read less': 'Read More' }}</a>
}
        </p>
    </div>

    <div class="population-summary" >
        <div class="title">Entitle Population Failing {{tableRowData.DIAG_DESC}} Out Diagnostic</div>
        <div class="cancel-action">
          <ap-button [label]="'CANCEL'" class="ap-mr-spacing-3" [btnType]="'secondary'"
                     (onClick)="closeModalCustom()">
          </ap-button>
        </div>
    </div>
    @if (diagData && diagData.safeCopyArr) {
<div class="records-summary">
        <span>Total Records: {{diagData.safeCopyArr.length}}</span>
        @if (colSearch.length>0) {
<span style="margin-left: 20px;">Filterd: {{diagData.data.length}}</span>
}
    </div>
}

    <div class="detail-diag-table-region">
        @if (gridLoading) {
          <div class="detail-diag-table-loader">
            <ap-loading [loadingType]="'circular'" [indeterminate]="true" [compact]="true"></ap-loading>
          </div>
}

        @if (!gridLoading && !diagData?.header?.length) {
<div
             class="detail-diag-empty-state"
             style="padding: 24px; text-align: center; color: #495057;">
            <span class="Appkit4-icon icon-information-outline" style="font-size: 18px; margin-right: 6px;"></span>
            <span>No records found</span>
        </div>
}

    @if (!gridLoading && diagData?.header?.length) {
      <div class="detail-diag-table-scroll">
        <table mat-table [dataSource]="diagData.data" matSort class="detail-diag-mat-table p-datatable-gridlines p-datatable-striped">
          @for (col of visibleDiagColumns; track col.map; let i = $index) {
            <ng-container [matColumnDef]="col.map">
              <th mat-header-cell *matHeaderCellDef
                  [style.width.px]="col.width"
                  [class.detail-diag-amount-col]="tableRowData.DIAG_NAME == col.map"
                  [ngClass]="{'color-red': tableRowData.DIAG_NAME == col.map}">
                <div class="detail-diag-header-stack">
                  <div class="detail-diag-sort-target" mat-sort-header>
                    <span class="detail-diag-col-label">{{ col.label }}</span>
                  </div>
                  @if (getFilterOption(col.map); as filterOption) {
                    <ap-dropdown #mutlSelect class="p-column-filter" [selectType]="'multiple'" [enableNgContent]="false"
                        [list]="filterOption.dropdownValues" [optionName]="'value'" [optionValue]="'value'"
                        [title]="'All'" [inputAriaLabel]="filterOption.key + ' filter'" [hideTitleOnInput]="true"
                        [showSearchbox]="true" [showSelectAll]="true" [clearSearchKeyword]="true"
                        (onFilterResult)="onDropdownFilterResult(filterOption, $event)"
                        [(ngModel)]="filterOptions[getFilterOptionIndex(col.map)].filterUserInput"
                        (onSelect)="filterMultiSelectCol($event.selected, filterOption, getFilterOptionIndex(col.map))"
                        (mousedown)="onFilterControlClick($event, getFilterOptionIndex(col.map))"
                        (click)="onFilterControlClick($event, getFilterOptionIndex(col.map))">
                    </ap-dropdown>
                  }
                </div>
              </th>
              <td mat-cell *matCellDef="let rowData"
                  [style.width.px]="col.width"
                  [style.height.px]="diagData.settings.default_row_height <= 30 ? 38 : diagData.settings.default_row_height"
                  [class.detail-diag-amount-col]="tableRowData.DIAG_NAME == col.map"
                  [ngClass]="{'text-align-right': col.data_type == 'number' && col.format == 'numberWithCommas'}">
                @if (col.drilldown != null && col.format == 'color-dot') {
                  <span style="padding: 5px 8px 0px 8px; cursor: pointer;"
                        class="Appkit4-icon icon-link-outline link drilldown-clickable"
                        (click)="redirectDrillDown(rowData, i)">
                    @if (tableRowData.DIAG_NAME == col.map) {
                      <span style="padding-left:5px;color:#495057">
                        @if (rowData.AMT != null) {
                          <span [ngClass]="{'text-red': rowData.AMT < 0 }"> {{rowData.AMT | number:'1.0-0'}}</span>
                        }
                        @if (rowData.AMT == null) {
                          <span> Yes </span>
                        }
                      </span>
                    }
                  </span>
                }
                @if (col.drilldown != null && col.format != 'color-dot') {
                  <span>
                    <span [ngClass]="{'Appkit4-icon icon-link-outline link': col.drilldown != null}"
                          class="drilldown-clickable"
                          style="padding: 5px 8px 0px 8px; cursor: pointer;"
                          (click)="redirectDrillDown(rowData, i)"></span>
                    <span> {{rowData[col.map]}} </span>
                  </span>
                }
                @if (col.drilldown == null && col.format != 'numberWithCommas') {
                  <span>{{rowData[col.map]}} </span>
                }
                @if (col.drilldown == null && col.data_type == 'number' && col.format == 'numberWithCommas') {
                  <span [ngClass]="{'text-red': rowData[col.map] < 0 }">
                    {{rowData[col.map] | number:'1.0-0' }}
                  </span>
                }
              </td>
            </ng-container>
          }

          <tr mat-header-row *matHeaderRowDef="diagDisplayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: diagDisplayedColumns"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" [attr.colspan]="visibleColumnCount" style="text-align: center">
              No records found
            </td>
          </tr>
        </table>
      </div>
    }

    </div>
  </div>
}
  </div>
</ap-modal>
